import { ConfirmPositiveModal } from '@/shared/components/confirmation'

interface Props {
  open: boolean
  confirming: boolean
  onClose: () => void
  onConfirm: () => void
}

/** BFP-1142 Figma 219:2415 — confirm before editing a Live / Paused survey. */
export function LiveEditConfirmDialog({ open, confirming, onClose, onConfirm }: Readonly<Props>) {
  return (
    <ConfirmPositiveModal
      open={open}
      iconVariant="liveEdit"
      headline="Are you sure you want to edit this survey?"
      bodyLines={[
        'This survey is currently live. You can edit this survey content and republish the changes.',
      ]}
      dismissLabel="Cancel"
      confirmLabel="Edit Survey"
      confirmDisabled={confirming}
      confirmPending={confirming}
      onDismiss={onClose}
      onConfirm={onConfirm}
      allowDismiss={!confirming}
      dialogTestId="live-edit-confirm-dialog"
      dismissTestId="live-edit-confirm-cancel"
      confirmTestId="live-edit-confirm-edit"
    />
  )
}
